import providerService from '../provider/ProviderService'
import ApiService from '../ApiService'
import axios from 'axios'

const copaymentService = {
  async getProviders() {
    const data = await providerService.getProviders()
    return data.data
  },
  getCopayment(idProvider) {
    // return ApiService.get(`copayment/${idProvider}`)
    return axios.get(`http://104.248.183.112:3001/copayment/${idProvider}`)
  },
  updateCopayment(file, id) {
    // return ApiService.postFile(`/copayment/update/${id}`, file)
    const formData = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };
    formData.append("attachment", file);
    return axios.post(`http://104.248.183.112:3001/copayment/update/${id}`, formData, { headers })
  }
}

export default copaymentService
